module.exports = __webpack_public_path__ + "static/media/Temp-dom2.92a92d4a.svg";